"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterPingPongMessages = exports.PingWS = void 0;
const pingpongws_types_1 = require("@cs124/pingpongws-types");
Object.defineProperty(exports, "filterPingPongMessages", { enumerable: true, get: function () { return pingpongws_types_1.filterPingPongMessages; } });
function PingWS(ws, o = {}) {
    const { interval, timeout, verbose, useOtherMessages, logDisconnects } = Object.assign(Object.assign({}, pingpongws_types_1.pingPongDefaultOptions), o);
    let pingTimer;
    let nonce;
    let pingTimeout;
    let seenInterval = false;
    function startPingTimer() {
        pingTimer = setInterval(() => {
            if (pingTimeout) {
                clearTimeout(pingTimeout);
            }
            if (seenInterval) {
                seenInterval = false;
                return;
            }
            nonce = Math.floor(Math.random() * 1024 * 1024);
            if (verbose) {
                console.debug(`${new Date().toISOString()}: -> ping ${nonce}`);
            }
            ws.send(JSON.stringify(pingpongws_types_1.PingMessage.check({ type: "ping", nonce })));
            pingTimeout = setTimeout(() => {
                if (logDisconnects) {
                    console.warn(`${new Date().toISOString()}: ping timeout: reconnecting`);
                }
                ws.reconnect();
            }, timeout);
        }, interval);
    }
    if (ws.readyState === ws.OPEN) {
        startPingTimer();
    }
    else {
        ws.addEventListener("open", startPingTimer);
    }
    ws.addEventListener("message", ({ data }) => {
        const message = JSON.parse(data);
        if (pingpongws_types_1.PingMessage.guard(message) && message.nonce === nonce && pingTimeout) {
            if (verbose) {
                console.debug(`${new Date().toISOString()}: <- ping ${nonce}`);
            }
            clearTimeout(pingTimeout);
        }
        else if (pingpongws_types_1.PongMessage.guard(message)) {
            ws.send(data);
        }
        else if (useOtherMessages) {
            if (verbose) {
                console.debug(`${new Date().toISOString()}: <- another message`);
            }
            seenInterval = true;
            pingTimeout && clearTimeout(pingTimeout);
        }
    });
    ws.addEventListener("close", () => {
        if (pingTimer) {
            clearInterval(pingTimer);
        }
        if (pingTimeout) {
            clearTimeout(pingTimeout);
        }
    });
    return ws;
}
exports.PingWS = PingWS;
//# sourceMappingURL=index.js.map